import React, { useState, useEffect } from "react";
import "./style.scss";

const IMAGE_CHECK_INTERVAL = 3000; // 3 seconds
const MAX_IMAGES = -30;

const Explorer = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    // Function to fetch images
    const fetchImages = async () => {
      try {
        const response = await fetch("https://www.dreamgirlstudio.ai/view");
        const data = await response.json();

        console.log("responsedata", data);
        // Concatenate old images with new ones and slice the array to keep the last 30 images
        console.log ("sliced array", data.slice(MAX_IMAGES));
        setImages(data.slice(MAX_IMAGES));
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };

    // Initial fetch
    fetchImages();

    // Set interval to fetch every 5 seconds
    const interval = setInterval(fetchImages, IMAGE_CHECK_INTERVAL);

    // Cleanup the interval on unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="explorer">
        <h1>Dream Girls Explorer</h1>
        <p>
            Check out the Dream Girls as they're created <i>LIVE!</i>
            <br />
            <br />
            -&nbsp;<i style={{color: "white"}}>Or&nbsp;</i>-
            <br />
            <br />
            <a href="https://www.dreamgirlstudio.ai/playground" target="_blank" rel="noreferrer"><i>Make Your Own</i></a>
        </p>
      <div className="image-queue">
        {images.map((src, index) => (
            <a href={src} target="_blank" rel="noreferrer" key={index}>
                <img src={src} alt={`Image ${index}`} />
            </a>
        ))}
      </div>
    </div>
  );
};

export default Explorer;
